import { render, staticRenderFns } from "./Evento_pais_prematch.vue?vue&type=template&id=c9b4358c&scoped=true&"
import script from "./Evento_pais_prematch.vue?vue&type=script&lang=js&"
export * from "./Evento_pais_prematch.vue?vue&type=script&lang=js&"
import style0 from "./Evento_pais_prematch.vue?vue&type=style&index=0&id=c9b4358c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b4358c",
  null
  
)

export default component.exports